const state = {
	/**
	 * 导航
	 * title: 标题
	 * name: 路由唯一标识
	 * type: 后台字典类型
	 * isShow: 首页导航 是否显示
	 * path: 路由
	 */
	navOptions: [
		{ title: "网站首页", name: 'Home', type: "home", isShow: true, path: "/" },
		{ title: "新闻动态", name: 'News', type: "news", isShow: true, path: "/news" },
		{ title: "关于我们", name: 'About', type: "about", isShow: true, path: "/about" },
		{ title: "业务介绍", name: 'Work', type: "work", isShow: true, path: "/work" },
		{ title: "诚聘英才", name: 'Recruit', type: "recruit", isShow: true, path: "/recruit" },
		{ title: "联系我们", name: 'Contact', type: "contact", isShow: true, path: "/contact" },
	],
}

const mutations = {

}

const actions = {

}

export default {
	state,
	mutations,
	actions
}
